<template>
  <div class="container__" id="patents">
    <div class="_insideContainer">
      <Title type="light" :tag="$t('aboutus.patent.tag')" :title="$t('aboutus.patent.title')" />
      <div v-if="loading" style="padding: 50px 0; color: #666;">Yükleniyor...</div>
      <List v-else type="light" :list="firebasePatents" :animation="true" />
    </div>
  </div>
</template>

<script>
import Title from "../common/Title";
import List from "../common/List";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getApp } from "firebase/app";

export default {
  name: "Patent",
  components: { Title, List },
  data() { return { firebasePatents: [], loading: true }; },
  async mounted() {
    try {
      const db = getFirestore(getApp());
      const qSnap = await getDocs(collection(db, "patentler"));
      let items = [];
      
      qSnap.forEach((doc) => {
        let data = doc.data();
        
        // ÖNEMLİ KONTROL: Patent detayı (açıklama, görsel, teknik özellik) girilmiş mi?
        let routeLink = "coming-soon";
        if (data.description || data.techSpecs || data.image || data.extraImage || data.extraDescription) {
          routeLink = `patents/${doc.id}`; // Detay girilmişse şablona git
        } else if (data.link) {
          routeLink = data.link; // Admin sadece harici bir dış bağlantı girdiyse onu kullan
        }

        items.push({
          id: doc.id,
          title: data.title,
          link: routeLink, 
          tag: data.tags || [],
          buttonText: "Daha Fazla Bilgi", // veya this.$t("aboutus.patent.buttonText")
          order: data.order || 9999
        });
      });
      
      items.sort((a, b) => a.order - b.order);
      this.firebasePatents = items;
    } catch (e) { console.log(e); } finally { this.loading = false; }
  }
};
</script>
<style scoped> .container__ { padding-top: 50px; max-width: 1900px; width: 100%; padding: 50px 5% 0 5%; background-color: white; } </style>